import { render } from "./TemplateModalVmsBoard.vue?vue&type=template&id=5a0ff0ad&ts=true"
import script from "./TemplateModalVmsBoard.vue?vue&type=script&lang=ts"
export * from "./TemplateModalVmsBoard.vue?vue&type=script&lang=ts"

import "./TemplateModalVmsBoard.vue?vue&type=style&index=0&id=5a0ff0ad&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__